export const STATUS_COLORS = {
  submitted: 'bg-blue-50 text-blue-600',
  under_review: 'bg-amber-50 text-amber-600',
  approved: 'bg-green-50 text-green-600',
  partially_approved: 'bg-yellow-50 text-yellow-600',
  rejected: 'bg-red-50 text-red-600',
  cancelled: 'bg-gray-100 text-gray-500',
  pending: 'bg-gray-100 text-gray-500',
  cancellation_requested: 'bg-amber-50 text-amber-600',
  pending_sponsor_approval: 'bg-purple-50 text-purple-600',
  delivered: 'bg-teal-50 text-teal-700',
};

export const STATUS_ICONS_MAP = {
  approved: 'CheckCircle',
  rejected: 'XCircle',
  partially_approved: 'AlertCircle',
  delivered: 'PackageCheck',
};

export const HISTORY_COLORS = {
  request_created: 'text-blue-600 bg-blue-50',
  request_reviewed: 'text-green-600 bg-green-50',
  request_cancelled: 'text-red-600 bg-red-50',
  cancellation_requested: 'text-amber-600 bg-amber-50',
  cancellation_rejected: 'text-rose-600 bg-rose-50',
};
